import { DocFileProcessState, DocScanStatus, DocSupersedeState, type DocumentView } from '../types/documentCapture.types';

/**
 * Viewer edge states (86d3rrfdk). There is NO discriminator field on the wire — these are derived
 * from the 200 payload, or from a 404.
 *
 * The four design states collapse to these because "not captured yet" is indistinguishable from
 * "not found / no access" via the API (all three are the same neutral 404, by design — that
 * indistinguishability is the treasury-existence security property). So: withdrawn and processing
 * come from a 200; everything unavailable is one neutral 404.
 */
export type ViewerState = 'ready' | 'processing' | 'withdrawn' | 'notfound' | 'error';

/** Derive the viewer state from a successful document fetch. `null` means the fetch 404'd. */
export function deriveViewerState(doc: DocumentView | null): ViewerState {
  if (doc === null) return 'notfound';
  if (doc.status === DocScanStatus.Rejected) return 'withdrawn';

  // Ready = there's a serving version with rendered pages.
  const activeReady =
    doc.activeFileId != null &&
    doc.pageCount > 0 &&
    doc.versions.some(
      (v) => v.supersedeState === DocSupersedeState.Active && v.processState === DocFileProcessState.Decoded
    );
  if (activeReady) return 'ready';

  // Exists, but nothing serviceable yet — decode in flight, or its only version failed/quarantined.
  return 'processing';
}
